import { Tool } from '../../types';

export const paymentTools: Tool[] = [
  {
    id: 'stripe',
    name: 'Stripe',
    category: 'Payment Processing',
    description: 'Online payment processing and financial infrastructure',
    pricing: ['low', 'medium'],
    features: ['integrations', 'security', 'scalability'],
    bestFor: ['startup', 'small-business'],
    compatibleWith: ['e-commerce', 'saas', 'marketplace'],
    goals: ['increase-sales', 'streamline-operations'],
    industries: ['technology', 'retail', 'finance'],
    website: 'https://stripe.com',
    imageUrl: 'https://logo.clearbit.com/stripe.com',
    idealStages: ['launching', 'growing', 'scaling'],
    technicalLevel: ['intermediate', 'advanced'],
    minTeamSize: 'solo'
  },
  {
    id: 'square',
    name: 'Square',
    category: 'Payment Processing',
    description: 'Payment processing and point-of-sale solutions',
    pricing: ['low', 'medium'],
    features: ['ease-of-use', 'mobile', 'integrations'],
    bestFor: ['small-business', 'freelancer'],
    compatibleWith: ['retail', 'service-business'],
    goals: ['increase-sales', 'streamline-operations'],
    industries: ['retail', 'trades', 'creative'],
    website: 'https://squareup.com',
    imageUrl: 'https://logo.clearbit.com/squareup.com',
    idealStages: ['launching', 'growing'],
    technicalLevel: ['beginner', 'intermediate'],
    minTeamSize: 'solo'
  },
  {
    id: 'paypal',
    name: 'PayPal',
    category: 'Payment Processing',
    description: 'Online payment system and financial technology platform',
    pricing: ['low', 'medium'],
    features: ['ease-of-use', 'mobile', 'security'],
    bestFor: ['freelancer', 'small-business'],
    compatibleWith: ['e-commerce', 'service-business'],
    goals: ['increase-sales', 'expand-customer-base'],
    industries: ['retail', 'creative', 'consulting'],
    website: 'https://www.paypal.com',
    imageUrl: 'https://logo.clearbit.com/paypal.com',
    idealStages: ['launching', 'growing'],
    technicalLevel: ['beginner'],
    minTeamSize: 'solo'
  }
];